import { createSelector } from "@ngrx/store";
import { HomeBudgetSubpage, HomeBudgetSubpages } from "./budget.data";
import { routerStateSelector } from "../router.state";

const router = createSelector(routerStateSelector, (state) => state.state);

export const budgetSubpageReselector = createSelector(
    router,
    (router): HomeBudgetSubpage => {
      const [_, mainRoute, subRoute ] = router.url.split("/").map(w => w.toLocaleLowerCase())
      if (mainRoute === 'budget' && HomeBudgetSubpages.some(p => subRoute === p)) return subRoute as HomeBudgetSubpage
      return null
    }
)